module.exports = __webpack_public_path__ + "img/arrow.eff63966.png";